import { useEffect } from 'react'
import ym from "react-yandex-metrika"
import { Outlet, useLocation, useNavigate } from "react-router"
import { useSessionContext } from "src/hooks"

const LocationProvider = () => {
    const location = useLocation()
    const { rounds } = useSessionContext()
    const navigate = useNavigate()

    useEffect(() => {
        const pathname = location.pathname
        switch (pathname) {
            case "/":
                ym('hit', '/')
                break
        }

        const isFormWasSent = localStorage.getItem("danetki-form-sent")
        // Если пользователь до этого заполнял форму
        if (isFormWasSent && pathname === "/form/") {
            navigate("/")
        }

        // Редиректим, если пользователь перезагрузился и попал на эти страницы
        if (!rounds.length && ["/game/", "/mid-game/"].includes(pathname)) {
            navigate("/")
        }
    }, [location, navigate])

    return <Outlet/>
}

export default LocationProvider